import React from 'react';
import { Container } from 'components/UI';
import { Title, Image, Icon } from '@landing/ui';

import * as styles from './Intro.module.scss';

export default function Intro({ title, description, dates, location, address, image }) {
  return (
    <Container className={styles.container}>
      <div className={styles.layout}>
        <Icon name="owl-soul-logo" className={styles.logo} />
        <Title tag="h1" color="white" className={styles.title}>
          {title.map(item => (
            <span key={item} className={styles.titleRow}>
              {item}
            </span>
          ))}
        </Title>
        <div className={styles.info}>
          <p className={styles.dates}>{dates}</p>
          <p className={styles.description}>{description}</p>
          <div className={styles.location}>
            <Icon name="location" className={styles.pin} />
            <div>
              <p className={styles.office}>{location}</p>
              <p className={styles.address}>{address}</p>
            </div>
          </div>
          <Image className={styles.picture} classImage={styles.image} src={image} lazy={false} />
        </div>
      </div>
    </Container>
  );
}
